<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>Максимальное количество символов</label>
        <input
          type="number"
          min="0"
          class="form-control"
          v-model="control.maxLength"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'raTextConfigComponent',
  props: {
    control: {
      type: Object
    }
  }
};
</script>

<style scoped></style>
